import { useEffect, useContext, useCallback, useState } from "react";
import { Modal, Button, Form, message, Divider, Alert } from "antd";
import { DataTableContext } from "../../context/DataTableContext";
import styles from "./formModal.module.css";
import { FormFields } from "../PageData";
import TextArea from "antd/lib/input/TextArea";

interface Props {
  formFields?: FormFields[];
  refetch: any;
  title: string;
  useRemoveMutation: any;
  customRefetch?: any;
}

const DeleteModal = ({ refetch, useRemoveMutation, customRefetch }: Props) => {
  const { deleteModalVisible, setDeleteModalVisible, setId, id, ids } =
    useContext(DataTableContext);
  const [removeMutation, { loading: updateLoading, data: deletedData }] =
    useRemoveMutation();
  const [reason, setReason] = useState("");
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    try {
      if (id) {
        await removeMutation({
          variables: {
            ids: [id],
            reason,
          },
        });
      }
      if (ids.length > 0) {
        await removeMutation({
          variables: {
            ids,
            reason,
          },
        });
      }
    } catch (error: any) {
      errorMessage(error.message);
    }
  };

  const handleCancel = useCallback(() => {
    setDeleteModalVisible(false);
    form.resetFields();
    setId("");
  }, [form, setId, setDeleteModalVisible]);

  const successMessage = useCallback((text: string) => {
    message.success(text);
  }, []);

  useEffect(() => {
    if (deletedData) {
      successMessage("Successfully deleted");
      handleCancel();
      refetch();
      customRefetch && customRefetch();
    }
  }, [deletedData, customRefetch, refetch, handleCancel, successMessage]);

  const errorMessage = (text: string) => {
    message.error(text);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Modal
        style={{ borderRadius: 8, paddingBottom: 0 }}
        destroyOnClose={true}
        title="Delete"
        visible={deleteModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Alert
            message="After you delete this item, it will be gone forever. Please be certain. All classes which was bought will be refunded."
            type="warning"
            className={styles.bottomMargin}
          />
          <Form.Item
            label="Reason"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            name="reason"
          >
            <TextArea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              autoSize={{ minRows: 3, maxRows: 5 }}
            />
          </Form.Item>

          <Divider />
          <Form.Item style={{ textAlign: "center" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Button
                htmlType="button"
                className={styles.customCancelBtn}
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                className={styles.customApproveBtn}
                type="primary"
                color="danger"
                htmlType="submit"
                loading={updateLoading}
              >
                Delete
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default DeleteModal;
